<div class="list" cdkMenu>
  @for (municipality of municipalities(); track municipality.name) {
    <button
      type="button"
      class="list__button"
      cdkMenuItem
      (cdkMenuItemTriggered)="setSelectedMunicipality(municipality)">
      <app-dot [outageType]="municipality.outageType" />
      <span class="list__label e-text-interactive-md">
        {{ municipality.name }},
        <span class="e-sr-only">{{ municipality.outageType | outageType }}, </span>
        {{ municipality.affectedCustomers | affectedCount }}
      </span>
      <div class="list__icon">
        <e-icon name="arrowRightCircleColor" size="sm" />
        <e-icon name="arrowRightCircleFilledColor" size="sm" />
      </div>
    </button>
  }
</div>
